import { initialState, PartnerState } from './store'
import { Module } from 'vuex'

export const partnersStore: Module<any, PartnerState> = {
  namespaced: true,
  state: initialState
  // getters,
  // mutations,
  // actions
}
